import React from 'react'
import { CurecallTextarea, CurecallTextareaProps } from '@honestica/curecall-ui'

interface TextareaForChatProps {
  onCmdEnter?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

const TextareaForChat: React.FC<CurecallTextareaProps & TextareaForChatProps> = ({
  onCmdEnter,
  ...otherProps
}) => {
  const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = (event) => {
    if (
      (event.key === 'Enter' && event.metaKey) || // CMD+Enter for macOS
      (event.key === 'Enter' && event.ctrlKey) // CTRL+Enter for other systems
    ) {
      if (onCmdEnter) {
        event.preventDefault()
        onCmdEnter(event)
      }
    }
  }

  return <CurecallTextarea onKeyDown={handleKeyDown} {...otherProps} />
}

export default TextareaForChat
